<template>
  <HeaderComponent
    :excelBtn = "this.excelBtn"
    activePage = "ListDTPage"
  />
  <main class="main">
    <div class="wrapper">
      
      <!-- <div class="wrapper__button">
        <download-excel
        class="btn btn-default"
        :data="this.getList()"
        :fields="json_fields"
        :meta="json_meta"
        worksheet="My Worksheet"
        name="filename.xls"
        >
          <img src="@/assets/img/icons/to_excel.svg" />
        </download-excel>
        <router-link :to="{ name: 'ReportsPage'}">
            <span class="declaration__num">
                <img src="@/assets/img/icons/reports.svg" alt="" width="30" height="40">
            </span>
        </router-link>
      </div> -->

      <!-- <ListTitle /> -->
      <ListDTFilter />
      <ListDTSort />
      <ListDTItems />
      <!-- <ListDTMobBar /> -->
    </div>
  </main>
  <div class="pagination">
    <ListDTPagination />           
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

import HeaderComponent from "@/components/Header";
import ListDTFilter from "@/components/ListDT/Filter"
import ListDTSort from "@/components/ListDT/Sort"
// import ListTitle from "@/components/ListDT/Title"
import ListDTItems from "@/components/ListDT/ItemsDT"
import ListDTPagination from "@/components/ListDT/Pagination"
// import ListDTMobBar from "@/components/ListDT/MobBar"

// import JsonExcel from "vue-json-excel3";
// Описание компонента vue-json-excel3
/*https://github.com/jecovier/vue-json-excel/blob/master/JsonExcel.vue*/


export default {
  name: "ListDTPage",
  components: {
    HeaderComponent,
    // ListTitle,
    ListDTFilter,
    ListDTSort,
    ListDTItems,
    ListDTPagination,
    // ListDTMobBar,
  },
  data: () => {
    return {
      excelBtn: {
          show: true,
          json_fields: {
            "№ папки": "nd",
            "Процедура": "edproc",
            "Рег. номер": "regnum",
            "Статус": "statused",
            "Доп.статус": {
                field: "dopstatused",
                    callback: (value) => {
                    return `Тест обработки - ${value.slice(0, 50)}`;
                },
            },
            "Отправитель": "sender",
            "Получатель": "recipient",
            "Дата": "datedt"
          },
          json_meta: [
            [
              {
                  key: "charset",
                  value: "utf-8",
              },
            ],
          ],
          getData: () => [],
          worksheet: "Список ДТ",
          file_name: "ListDT.xls",
      },       
    }
  },
  methods: {
    ...mapGetters("ListDT", ["getList"]),
    ...mapActions("ListDT", {
      refreshData: "autoRefresh",
      loadData: "loadListDataOnce"
    }),
  },
  mounted() {
    this.excelBtn.getData = this.getList
    // Для ускорения грузим только за 15 дней, параллельно грузим полные данные
    this.loadData()
    
    this.refreshData(300000)

  }
};

</script>